// libs
import React from 'react';

import { cn } from '@lyearn/style';
// components
import { Stack, Typography } from '@lyearn/ui';

// styles
import { itemSize } from './styles';

interface RatingItemNumberProps {
  value: string | number;
  size?: number;
  className?: string;
}

const RatingItemNumber = (props: RatingItemNumberProps) => {
  const { value, size = 22, className = 'text-text-primary bg-field' } = props;

  return (
    <Stack
      alignItems="center"
      className={cn('cursor-pointer rounded-24', itemSize(size), className)}
      justifyContent="center">
      <Typography variant="body-short-02">{value}</Typography>
    </Stack>
  );
};

export default RatingItemNumber;
